import React, {Component, createRef} from "react";
import {getFM, getSpan, isPortrait, ScrollSnap} from "../../Utilities/utils";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import c11 from "../../Resources/logos/Logo-sega copy.png";
import c12 from "../../Resources/logos/Logo-rovio copy.png";
import c13 from "../../Resources/logos/Logo-ironsource copy.png";
import c14 from "../../Resources/logos/Logo-Jamcity.png";
import c21 from "../../Resources/logos/Logo-Kwalee.png";
import c22 from "../../Resources/logos/Logo-outfit copy.png";
import c23 from "../../Resources/logos/Logo-Atari.png";
import c24 from "../../Resources/logos/Google Marketing Platform copy.png";
import c31 from "../../Resources/logos/Logo-smar+ copy.png";
import c32 from "../../Resources/logos/Logo-ubisoft.png";
import c33 from "../../Resources/logos/Logo-Xandr copy.png";
import c34 from "../../Resources/logos/Logo-anzu copy.png";
import format3 from "../../Resources/formats/icon_01_playable.svg";
import format1 from "../../Resources/formats/icon_02_display.svg";
import format2 from "../../Resources/formats/icon_03_rewarded.svg";
import format4 from "../../Resources/formats/icon_04_nativos.svg";
import format5 from "../../Resources/formats/icon_05_nativos.svg";
import MaxFooter from "../Footer";
import Slider from "react-slick";
import {injectIntl} from "react-intl";
import MaxButton from "../MaxButton";
import gsap from "gsap";
import BgGrid from "../BgGrid";

class PServicesIGAContent extends Component {

    IGAImagesSlide : any = {
        format1, format2, format3, format4, format5
    }

    getIGAImagesSlide(name: string) {
        return (this.IGAImagesSlide)[name]
    }

    componentDidMount() {
        gsap.timeline({
            scrollTrigger: {
                trigger: '.p-services-content-template',
                start: 'end',
                end: '+=60%',
                scrub: true,
            }
        }).fromTo(".row-odd", {
            x: '200%',
        },{duration: 5,x:'-10%'},1).fromTo(".row-even", {
            x: '-200%',
        },{duration: 5,x:'10%'},1)

    }


    render() {
        //amplitude.logEvent('In_game_loaded')
        isPortrait() && ScrollSnap()
        return <div>
            <div className={"svc-partners-content"}>
                <BgGrid className={'pservices-bg-grid'} id={'p-bg2'}
                        hLines={5} vLines={4} />
                <div className={'service-page'}>
                    {this.getAccordionHeader()}
                    <div className={'svc-title-header'}
                         style={{margin: 'auto 0'}}>
                        {getSpan(['services_IGA_partners'])}
                    </div>

                    <div className={'svc-slide-subtitle svc-partners-subtitle'}>
                        {getSpan(['pservices_IGA_partners_text',
                            'pservices_IGA_partners_text_2'])}
                    </div>
                    <div className={"svc-partners"} style={{overflowX:"hidden"}}>
                        <img src={c11} className={"partners row-odd"} alt={'Partner'}/>
                        <img src={c12} className={"partners row-odd"} alt={'Partner'}/>
                        <img src={c13} className={"partners row-odd"} alt={'Partner'}/>
                        <img src={c14} className={"partners row-even"} alt={'Partner'}/>
                        <img src={c21} className={"partners row-even"} alt={'Partner'}/>
                        <img src={c22} className={"partners row-even"} alt={'Partner'}/>
                        <img src={c23} className={"partners row-odd"} alt={'Partner'}/>
                        <img src={c24} className={"partners row-odd"} alt={'Partner'}/>
                        <img src={c31} className={"partners row-odd"} alt={'Partner'}/>
                        <img src={c32} className={"partners row-even"} alt={'Partner'}/>
                        <img src={c33} className={"partners row-even"} alt={'Partner'}/>
                        <img src={c34} className={"partners row-even"} alt={'Partner'}/>
                    </div>
                </div>
            </div>
            <div className={"svc-formatos-content"}>
                <BgGrid className={'pservices-bg-grid'} id={'p-bg2'}
                        hLines={5} vLines={4}/>
                <div className={'service-page'}>
                    {this.getAccordionHeader()}
                    <div className={'svc-title-header'}
                         style={{margin: 'auto 0'}}>
                        {getSpan(['services_IGA_formats'])}
                    </div>
                    <Slider className={"slides accessibility-img"}
                            {...settings}>
                        <div id={'IGA0'} className={'svc-slide-item'}>
                            <div ref={createRef()} className={"slide-content"}>
                                <div id={'IGA0-top'} className={'slide-top'}>
                                    <div className={"slide-header"}>
                                        <img key={'title'} src={this.getIGAImagesSlide('format3')} alt={'alt'}/></div>
                                </div>
                                <div id={'IGA0-title'}
                                     className={"slide-title svc-slide-title"}>
                                    {getSpan(['services_IGA_format3'])}
                                </div>
                                <div id={'IGA0-subtitle'}
                                     className={"accessibility-font svc-slide-subtitle"}>
                                    {getSpan(['services_IGA_format3_description'])}
                                </div>
                                <div className={'button-width'}>
                                    <MaxButton width={'6vw'} clickEvent={() => {
                                        /*props.amplitude.logEvent('showcase_clicked')*/
                                        window.open("https://showcase.etermax.com", "_blank")
                                    }}>
                                        {`services_IGA_showcase_button`}
                                    </MaxButton>
                                </div>
                            </div>
                            <div ref={createRef()} className={'slide-msg'}>
                            </div>
                        </div>
                        {
                            this.props.cards.map((card:any) => {
                                return (card.index !== 3) ? this.getSlideItemsWithMetric(card) : null
                            })
                        }
                    </Slider>
                </div>
            </div>
            <MaxFooter id={'pScene11'} className={'content accessibility-img'}/>
        </div>;
    }

    getSlideItemsWithMetric(card: any) {
        return <div
            id={'IGA1'}
            key={card.format}
            className={'svc-slide-item'}
        >
            <div ref={createRef()}
                 className={"slide-content"}>
                <div id={'IGA0-top'}
                     className={'slide-top'}>
                    <div className={"slide-header"}><img key={'title'} src={this.getIGAImagesSlide(card.format)}
                                                         alt={'alt'}/></div>
                </div>
                <div id={'IGA0-title'}
                     className={"slide-title svc-slide-title"}>
                    {getSpan([card.title])}
                </div>
                <div id={'IGA0-subtitle'}
                     className={"slider-subtitle"}>
                    {getSpan([card.subtitle])}
                </div>
                <div id={'IGA0-metrics'}
                    className={"slider-metrics"}>
                    {getSpan([card.stats])}
                </div>
                {/*<div className={'slide-content' + (props.clickable ? " clickable" : "not-clickable")}
                                 style={{position: 'absolute'}}/>*/}
            </div>
            <div ref={createRef()} className={'slide-msg'}>
            </div>
        </div>;
    }

    getAccordionHeader() {
        return <>
            {
                isPortrait() && <div onClick={this.closeAccordion}
                                     className={'p-services-title MuiButtonBase-root MuiAccordionSummary-root sc-acc-summary p-font-menu Mui-expanded'}>
                    <div
                        className={'MuiAccordionSummary-content Mui-expanded'}>{isPortrait() && getFM('home_IGA_title')}</div>
                    <div
                        className={'MuiButtonBase-root MuiIconButton-root MuiAccordionSummary-expandIcon Mui-expanded MuiIconButton-edgeEnd'}>
                        <ExpandMoreIcon fontSize={"large"}/></div>
                </div>}
        </>;
    }

    closeAccordion() {
        const accordionHeaderClassName = 'MuiButtonBase-root MuiAccordionSummary-root sc-acc-summary p-font-menu Mui-expanded';
        const accordionHeader = document.getElementsByClassName(accordionHeaderClassName)[0];
        accordionHeader.click()
    }
}

let settings = {
    dots: true,
    infinite: false,
    speed: 600,
    slidesToScroll: 1,
    slidesToShow: 1,
    vertical: false,
    adaptiveHeight: false,
    arrows: false,
    centerMode: true,
    variableWidth: false,
    centerPadding: '12px'
};

export default injectIntl(PServicesIGAContent);
